import styles from "./CreateUser.module.css";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import React, { useState } from "react";

import Input from "../input/Input";

import { signUpNewUser } from "../../../services/User.service";

const CreateUser = () => {

  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);


const handleUser = () => {
    console.log('name',name);
    console.log('email',email);
    signUpNewUser(email,password);
}

  return (
    <div className={styles.creatUserContainer}>
      <div className={styles.userInfoHeader}>
        <h2 className={styles.pageTitle}>Create User</h2>
        <span className={styles.pageSubtitle}>
          New User Creation
        </span>
      </div>
     
      <div className={styles.createUserForm}>
        <Row>
          <Col md={6}>
            <Input
              label="Name"
              name="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Input
              type="text"
              name="email"
              label="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Col>
          </Row>
          <Row>
          <Col md={6}>
            <Input
              type="text"
              name="password"
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Col>
          </Row>
          <Row>
          <Col md={6}>
          <Button className={styles.tourPosterUploadBtn}
         
          variant="dark" 
          onClick={handleUser}
        >
            SignUp
            </Button>
          </Col>
        </Row>
        
      </div>
    </div>
  );
};

export default CreateUser;
